import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { enums } from "../lib";

/**
 * Hook to check if the audit group is closed
 */
const useShouldShowCloseAuditPopup = (isSignatureRequired) => {
    const { auditsList, auditReview, dealerContacts, auditAssets } =
        useSelector((state) => state);

    return useMemo(() => {
        const isInReviewAudit =
            auditsList.item?.status === enums.status.audit.inReview ||
            auditsList.item?.status === enums.status.audit.pendingReview;

        const { altAssets } = auditReview;

        // Count pending decisions ONLY for mandatory assets. Non-mandatory assets should NOT block the close-audit popup.
        let pendingAssetDecision = 0;
        (auditAssets?.data ?? []).forEach((asset) => {
            if (asset.isMandatory && asset.status === 1) {
                pendingAssetDecision++;
            }
        });

        const auditAssetTotal =
            auditReview.auditAssets.approved + auditReview.auditAssets.rejected;

        const isAuditAssetClosed =
            auditReview.auditAssets.reissued === 0 &&
            auditReview.auditAssets.total - auditAssetTotal === 0;

        const isAltAssetClosed =
            (altAssets.total ?? 0) - (altAssets.resolved ?? 0) === 0;

        const isAuditStatusOpen =
            auditsList?.item?.status !== enums.status.audit.closed;

        // 🟢 New logic for signature requirement
        if (isSignatureRequired) {
            // if signature is required, dealerContacts length must be exactly 1
            if (dealerContacts?.length !== 1) {
                return false;
            }
        }

        return (
            pendingAssetDecision === 0 &&
            isInReviewAudit &&
            isAuditAssetClosed &&
            isAltAssetClosed &&
            isAuditStatusOpen
        );
    }, [
        auditReview,
        auditsList,
        dealerContacts,
        isSignatureRequired,
        auditAssets
    ]);
};

export default useShouldShowCloseAuditPopup;
